import { toast } from "react-toastify";
import axiosInstance from "../axiosInstance";
import APIPaths from "../../utils/APIPaths";
import RoutingPaths from "../../utils/RoutingPaths";
import {
  getOrgLogo,
  getOrgSign,
  getOrgStamp,
} from "./EditGeneralInformationService";

export const loginService = async (bodyObj, navigate) => {
  try {
    const { data } = await axiosInstance.post(APIPaths.SIGN_IN, bodyObj);
    const { token } = data.data;
    const { orgUserDto } = data.data;
    const { organizationDto } = data.data.orgUserDto;

    if (token) {
      sessionStorage.setItem("token", token);
      sessionStorage.setItem("OrgDetails", JSON.stringify(orgUserDto));
      sessionStorage.setItem("OrgDetails2", JSON.stringify(organizationDto));
      sessionStorage.setItem("UserRole", JSON.stringify(orgUserDto.userRole));
      sessionStorage.setItem(
        "googleClientId",
        JSON.stringify(data.data?.googleClientId),
      );
      sessionStorage.setItem(
        "googleRedirectUri",
        JSON.stringify(data.data?.googleRedirectUri),
      );

      sessionStorage.setItem(
        "SelectedBranch",
        JSON.stringify(data.data?.orgUserDto?.selectedBranchId),
      );
      if (
        organizationDto.consultants.length === 1 &&
        organizationDto.consultants[0].addressTiming.length === 0
      ) {
        sessionStorage.setItem(
          "showConsultantSetupModal",
          JSON.stringify(true),
        );
      }
      await getOrgLogoHandler(organizationDto);
      await getOrgStampHandler(organizationDto);
      await getOrgSignHandler(organizationDto);
      navigate(RoutingPaths.DASHBOARD);
      toast.success("Logged in successfully.");
      return;
    }
  } catch (error) {
    toast.error("The provided email ID or password is invalid.");
    return;
  }
};

export const signUpService = async (bodyObj, navigate) => {
  try {
    const response = await axiosInstance.post(APIPaths.SIGN_UP, bodyObj);

    if (response.status === 201) {
      navigate(RoutingPaths.PROFILE_VERIFY);
      toast.success(response.data?.message);
    }

    return response;
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ?? "An error occurred while signing up.";
    toast.error(errorMessage);
    return;
  }
};

export const getDegreeService = async () => {
  try {
    const response = await axiosInstance.get(APIPaths.GET_DEGREE_LIST);
    return response.data;
  } catch (error) {
    toast.error("Failed to load degree list. Please refresh.");
    return [];
  }
};

export const getSpecializationService = async () => {
  try {
    const response = await axiosInstance.get(APIPaths.GET_SPECIALIZATION_LISt);
    return response.data;
  } catch (error) {
    toast.error("Specialization list not loaded please refresh.");
    return [];
  }
};

export const forgotPasswordService = async (bodyObj, navigate) => {
  try {
    const response = await axiosInstance.post(
      APIPaths.FORGOT_PASSWORD,
      bodyObj,
    );

    if (response.status === 200) {
      navigate(
        RoutingPaths.FORGOT_PASSWORD_VALIDATE_TOKEN + "/" + bodyObj.userType,
        {
          state: {
            userName: bodyObj?.userName,
          },
        },
      );
      toast.success(response.data?.message);
    }

    return response;
  } catch (error) {
    const errorMessage =
      error.response?.data ?? "An error occurred while validating email.";
    toast.error(errorMessage);
    return;
  }
};

export const forgotPasswordValidateTokenService = async (bodyObj, navigate) => {
  try {
    const response = await axiosInstance.post(
      APIPaths.FORGOT_PASSWORD_VALIDATE_TOKEN,
      bodyObj,
    );
    if (response.status === 200) {
      navigate(RoutingPaths.FORGOT_PASSWORD_CHANGE + "/" + bodyObj.userType, {
        state: {
          userName: bodyObj?.userName,
          bodyObj,
        },
      });
      toast.success(response.data?.message);
    }

    return;
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ??
      "An error occurred while validating token.";
    toast.error(errorMessage);
    return;
  }
};

export const forgotPasswordChangeService = async (bodyObj, navigate) => {
  try {
    const response = await axiosInstance.post(
      APIPaths.FORGOT_PASSWORD_CHANGE,
      bodyObj,
    );

    if (response.status === 200) {
      navigate(RoutingPaths.LOGIN);
      toast.success(response.data?.message);
    }

    return response;
  } catch (error) {
    if (error.response?.data?.errors?.newPassword) {
      toast.error(error.response?.data?.errors?.newPassword);
    } else {
      toast.error(error.response?.data?.message);
    }
    return;
  }
};

const getOrgLogoHandler = async (organizationDto) => {
  const res = await getOrgLogo(organizationDto.id);

  if (res.status === 200) {
    const base64 = btoa(
      new Uint8Array(res.data).reduce(
        (data, byte) => data + String.fromCharCode(byte),
        "",
      ),
    );
    sessionStorage.setItem("OrgLogo", `data:image/jpeg;base64,${base64}`);
  } else {
    sessionStorage.setItem("OrgLogo", null);
  }
  return null;
};

const getOrgStampHandler = async (organizationDto) => {
  const res = await getOrgStamp(organizationDto.id);

  if (res.status === 200) {
    const base64 = btoa(
      new Uint8Array(res.data).reduce(
        (data, byte) => data + String.fromCharCode(byte),
        "",
      ),
    );
    sessionStorage.setItem("OrgStamp", `data:image/jpeg;base64,${base64}`);
  } else {
    sessionStorage.setItem("OrgStamp", null);
  }
  return null;
};

const getOrgSignHandler = async (organizationDto) => {
  const res = await getOrgSign(organizationDto.id);

  if (res.status === 200) {
    const base64 = btoa(
      new Uint8Array(res.data).reduce(
        (data, byte) => data + String.fromCharCode(byte),
        "",
      ),
    );
    sessionStorage.setItem("OrgSign", `data:image/jpeg;base64,${base64}`);
  } else {
    sessionStorage.setItem("OrgSign", null);
  }
  return null;
};

export const getAdminUserList = async () => {
  try {
    const URL = APIPaths.GET_ADMIN_USERS_LIST;
    const response = await axiosInstance.get(URL);
    if (response.status === 200) {
      return response.data;
    }
    return [];
  } catch (error) {}
};

export const addNewAdminUser = async (bodyObj) => {
  try {
    const response = await axiosInstance.post(
      APIPaths.ADD_NEW_ADMIN_USER,
      bodyObj,
    );

    if (response.status === 201) {
      toast.success(response.data.message);
      return response.data;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

export const updateAdminUserDetails = async (id, bodyObj, isBranchChanged) => {
  try {
    const URL = APIPaths.UPDATE_ADMIN_USER + id;
    const response = await axiosInstance.put(URL, bodyObj);
    if (response.status === 200) {
      if (!isBranchChanged) {
        toast.success(response.data.message);
      }

      return response.data;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

export const deleteAdminUserById = async (id) => {
  try {
    const response = await axiosInstance.delete(
      `${APIPaths.DELETE_ADMIN_USER}${id}`,
    );
    if (response.status === 200) {
      toast.success(response.data.message);
      return response.data;
    }
  } catch (error) {
    if (error.response.data) {
      toast.error(error.response.data);
    } else {
      toast.error("Something went wrong,Please try after some time");
    }
  }
};

export const getPrescriptionLayoutList = async () => {
  try {
    const URL = APIPaths.GET_PRESCRIPTION_LAYOUT_LIST;
    const response = await axiosInstance.get(URL);
    if (response.status === 200) {
      return response.data;
    }
    return [];
  } catch (error) {}
};

export const updatePrescriptionLayoutDetails = async (bodyObj) => {
  try {
    const URL = APIPaths.UPDATE_PRESCRIPTION_LAYOUT;
    const response = await axiosInstance.post(URL, bodyObj);
    if (response.status === 200) {
      toast.success(" Report Layout updated successfully");
      return response.data;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

export const getBirthdayEmailInfo = async () => {
  try {
    const URL = APIPaths.GET_BIRTHDAY_EMAIL_INFO;
    const response = await axiosInstance.get(URL);
    if (response.status === 200) {
      return response.data;
    }
    return [];
  } catch (error) {}
};

export const updateBirthdayEmailInfo = async (bodyObj) => {
  try {
    const URL = APIPaths.UPDATE_BIRTHDAY_EMAIL_INFO;
    const response = await axiosInstance.post(URL, bodyObj);
    if (response.status === 200) {
      toast.success(" Birthday Email Setting updated successfully");
      return response.data;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

export const getClientConsentForm = async (page, rowsPerPage, clientId) => {
  try {
    const response = await axiosInstance.get(
      `${APIPaths.GET_CLIENT_CONSENT_PDF_INFO}/${clientId}/${page}/${rowsPerPage}`,
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error("Error fetching consent form info", error);
  }
};

export const addClientConsentForm = async (bodyObj) => {
  try {
    const URL = APIPaths.ADD_CLIENT_CONSENT_FORM_INFO;
    const response = await axiosInstance.post(URL, bodyObj);
    if (response.status === 201) {
      return response;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

export const updateClientConsentForm = async (bodyObj) => {
  try {
    const URL = APIPaths.UPDATE_CLIENT_CONSENT_FORM_INFO;
    const response = await axiosInstance.put(URL, bodyObj);
    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

export const deleteConsentForm = async (id) => {
  try {
    const response = await axiosInstance.delete(
      `${APIPaths.DELETE_CLIENT_CONSENT_FORM_INFO}/${id}`,
    );
    if (response.status === 200) {
      toast.success("Consent form deleted successfully.");
      return response.data;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

export const getTreatmentPlanList = async () => {
  try {
    const URL = APIPaths.GET_TREATMENT_PLAN_LIST;
    const response = await axiosInstance.get(URL);
    if (response.status === 200) {
      return response.data;
    }
    return [];
  } catch (error) {}
};

export const addTreatmentPlan = async (bodyObj) => {
  try {
    const response = await axiosInstance.post(
      APIPaths.ADD_NEW_TREATMENT_PLAN,
      bodyObj,
    );

    if (response.status === 201) {
      toast.success(response.data.message);
      return response.data;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

export const updateTreatmentPlanDetails = async (bodyObj) => {
  try {
    const URL = APIPaths.UPDATE_TREATMENT_PLAN;
    const response = await axiosInstance.put(URL, bodyObj);
    if (response.status === 200) {
      toast.success(response.data.message);
      return response.data;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

export const getTreatmentPlanById = async (id) => {
  try {
    const URL = APIPaths.GET_TREATMENT_PLAN_BY_ID + id;
    const response = await axiosInstance.get(URL);
    if (response.status === 200) {
      return response.data;
    }
    return [];
  } catch (error) {
    if (error.response.data) {
      toast.error(error.response.data);
    } else {
      toast.error("Something went wrong");
    }
  }
};

export const deleteTreatmentPlanById = async (id) => {
  try {
    const response = await axiosInstance.delete(
      `${APIPaths.DELETE_TREATMENT_PLAN}${id}`,
    );
    if (response.status === 200) {
      toast.success(response.data.message);
      return response.data;
    }
  } catch (error) {
    if (error.response.data) {
      toast.error(error.response.data);
    } else {
      toast.error("Something went wrong,Please try after some time");
    }
  }
};

export const getTeethInfoList = async () => {
  try {
    const URL = APIPaths.GET_ALL_TEETH_INFO_LIST;
    const response = await axiosInstance.get(URL);
    if (response.status === 200) {
      return response.data;
    }
    return [];
  } catch (error) {}
};

export const importOrganizationsOldData = async (data) => {
  const response = await axiosInstance
    .post(APIPaths.IMPORT_ZIP_FILE, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      if (error.code === "ERR_NETWORK" || error.response.status === 500) {
        return { status: 500 };
      }
      return error.response;
    });
  return response;
};

export const validateDocumentTokenService = async (id, token) => {
  try {
    const response = await axiosInstance.post(
      APIPaths.SMS_ATTACHMENT_FILE,
      {},
      {
        params: {
          id: id,
          token: token,
        },
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/pdf, application/json",
        },
      },
    );

    if (response.status === 200) {
      toast.success(response.data?.message);
      const url = window.URL.createObjectURL(response.data);
      return url;
    } else {
      toast.error(response.data?.message || "Failed to validate token.");
    }
  } catch (error) {
    let errorMessage = "Something went wrong.";

    if (error.response?.data instanceof Blob) {
      try {
        const text = await error.response.data.text();
        const json = JSON.parse(text);
        errorMessage = json.message || errorMessage;
      } catch {}
    } else {
      errorMessage = error.response?.data?.message ?? errorMessage;
    }

    toast.error(errorMessage);
    return;
  }
};

export const getRoleList = async () => {
  try {
    const URL = APIPaths.GET_ALL_ROLE;
    const response = await axiosInstance.get(URL);
    if (response.status === 200) {
      return response.data;
    }
    return [];
  } catch (error) {}
};
